module.exports = __webpack_public_path__ + "media/svg/cash-multiple-a99d9d3b.svg";